import { ADD_AI_INVOICE, UPDATE_AI_INVOICE, DELETE_AI_INVOICE } from "./actionType"

const MOCK_INVOICES = [
  {
    id: 1,
    invoiceDate: "2024-01-15",
    clientName: "Acme Corporation",
    clientId: "acme",
    aiAssistType: "AI-Assist-Bundle",
    fromDate: "2024-01-01",
    toDate: "2024-01-31",
    amount: 1500.0,
  },
  {
    id: 2,
    invoiceDate: "2024-02-10",
    clientName: "TechVentures Ltd",
    clientId: "techventures",
    aiAssistType: "AI-Assist-Separate",
    fromDate: "2024-02-01",
    toDate: "2024-02-28",
    amount: 875.5,
  },
  {
    id: 3,
    invoiceDate: "2024-03-05",
    clientName: "Global Systems Inc",
    clientId: "global",
    aiAssistType: "AI-Assist-Bundle",
    fromDate: "2024-03-01",
    toDate: "2024-03-31",
    amount: 2200.0,
  },
  {
    id: 4,
    invoiceDate: "2024-04-12",
    clientName: "DataStream Corp",
    clientId: "datastream",
    aiAssistType: "AI-Assist-Separate",
    fromDate: "2024-04-01",
    toDate: "2024-04-30",
    amount: 1125.75,
  },
  {
    id: 5,
    invoiceDate: "2024-05-20",
    clientName: "NextGen Solutions",
    clientId: "nextgen",
    aiAssistType: "AI-Assist-Bundle",
    fromDate: "2024-05-01",
    toDate: "2024-05-31",
    amount: 3000.0,
  },
  {
    id: 6,
    invoiceDate: "2024-06-08",
    clientName: "Brightwave Technologies",
    clientId: "brightwave",
    aiAssistType: "AI-Assist-Separate",
    fromDate: "2024-06-01",
    toDate: "2024-06-30",
    amount: 960.0,
  },
  {
    id: 7,
    invoiceDate: "2024-07-18",
    clientName: "AlphaSoft Inc",
    clientId: "alphasoft",
    aiAssistType: "AI-Assist-Bundle",
    fromDate: "2024-07-01",
    toDate: "2024-07-31",
    amount: 4500.0,
  },
]

const initialState = {
  invoices: MOCK_INVOICES,
}

const aiInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AI_INVOICE:
      return {
        ...state,
        invoices: [action.payload, ...state.invoices],
      }
    case UPDATE_AI_INVOICE:
      return {
        ...state,
        invoices: state.invoices.map(inv =>
          inv.id === action.payload.id ? action.payload : inv
        ),
      }
    case DELETE_AI_INVOICE:
      return {
        ...state,
        invoices: state.invoices.filter(inv => inv.id !== action.payload),
      }
    default:
      return state
  }
}

export default aiInvoiceReducer
